import { createSlice } from "@reduxjs/toolkit";

interface RootState {
  dashboard: {
    accountantsCount: number;
    agreementsCount: number;
    customerCount: number;
    individualCount: number;
    legalFirmsCount: number;
    packageCount: number;
    supplierCount: number;
    userCount: number;
  };
}

const initialState: RootState['dashboard'] = {
  accountantsCount: 0,
  agreementsCount: 0,
  customerCount: 0,
  individualCount: 0,
  legalFirmsCount: 0,
  packageCount: 0,
  supplierCount: 0,
  userCount: 0
};

export const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {}
});

export const selectAllDashboardInfo = (state: RootState): RootState['dashboard'] => state.dashboard;

export default dashboardSlice.reducer;
